import roundToDecimal from '../../roundToDecimal'
// import { t } from 'i18next'
import { calculateFinalPrice, mapPeriodToBackend } from './calculateFinalPrice'
import { currencyStore } from '../../localization/currency'
import { switchRadioUI } from '../../utils/switchRadioUi'

export function rewritePrices(packages, store) {
  const currencyData = currencyStore.getSelectedCurr()
  const exchangeRate = currencyData?.currency
  const period = store.period

  packages.forEach(tariffEl => {
    const discountBlock = tariffEl.querySelector('[data-has-discount]')

    const roundType = period !== 1 ? 'floor' : 'ceil'

    const ipv4PriceEl = tariffEl.querySelector('[data-ipv4-price]')
    const ipv6PriceEl = tariffEl.querySelector('[data-ipv6-price]')

    if (!ipv4PriceEl || !ipv6PriceEl) return

    const ipv4Price = +ipv4PriceEl.getAttribute('data-ipv4-price')
    const ipv6Price = +ipv6PriceEl.getAttribute('data-ipv6-price')

    const ipv4DiscountPriceEl = tariffEl.querySelector('[data-ipv4-discount-price]')
    const ipv6DiscountPriceEl = tariffEl.querySelector('[data-ipv6-discount-price]')

    const ipv4DiscountPrice = ipv4DiscountPriceEl
      ? +ipv4DiscountPriceEl.getAttribute('data-ipv4-discount-price')
      : 0
    const ipv6DiscountPrice = ipv6DiscountPriceEl
      ? +ipv6DiscountPriceEl.getAttribute('data-ipv6-discount-price')
      : 0

    let finalIpv4DiscountPrice
    let finalIpv6DiscountPrice
    const finalIpv4Price = calculateFinalPrice(ipv4Price, period, exchangeRate)
    const finalIpv6Price = calculateFinalPrice(ipv6Price, period, exchangeRate)

    if (discountBlock) {
      finalIpv4DiscountPrice = calculateFinalPrice(ipv4DiscountPrice, period, exchangeRate)
      finalIpv6DiscountPrice = calculateFinalPrice(ipv6DiscountPrice, period, exchangeRate)

      /* Render the results */
      const priceDiscountEl = tariffEl.querySelector('[data-ipv4-discount-price]')
      if (priceDiscountEl) {
        priceDiscountEl.innerHTML =
          roundToDecimal(
            store.ipPrice === 0 ? finalIpv4DiscountPrice : finalIpv6DiscountPrice,
            roundType,
          ) + currencyData?.symbol
      }
    }

    /* Render the results */
    const priceEl = tariffEl.querySelector('[data-ipv4-price]')
    if (priceEl) {
      priceEl.innerHTML =
        roundToDecimal(store.ipPrice === 0 ? finalIpv4Price : finalIpv6Price, roundType) +
        currencyData?.symbol
    }

    const oldPriceEl = tariffEl.querySelector('[data-old-price]')
    if (oldPriceEl) {
      oldPriceEl.innerHTML =
        roundToDecimal(store.ipPrice === 0 ? finalIpv6Price : finalIpv4Price, roundType) +
        currencyData?.symbol
    }
  })
}

export function onIpSwitch({
  packages,
  packagesLinks,
  store,
  comparisonPriceBlock,
  oldPriceElms,
  elm,
}) {
  const value = elm.getAttribute('data-ip-btn')
  store.ipPrice = +value
  const locationId = document.querySelector('[data-location]')?.getAttribute('data-location')
  store.location = locationId ? locationId : ''

  switchRadioUI({ elm, attribute: '[data-ip-btn]' })

  rewritePrices(packages, store)

  /** Show old price if IPv6 is selected */
  if (store.ipPrice !== 0) {
    comparisonPriceBlock?.forEach(price => price?.classList?.add('with_sale'))
    oldPriceElms.forEach(el => (el.style.display = 'block'))
  } else {
    comparisonPriceBlock?.forEach(price => price?.classList?.remove('with_sale'))
    oldPriceElms.forEach(el => (el.style.display = 'none'))
  }

  generateTariffLink({ packagesLinks, store })
}

export function generateTariffLink({ packagesLinks, store }) {
  packagesLinks.forEach(link => {
    const ipv6 = store.ipPrice !== 0 ? true : false
    const period = mapPeriodToBackend(store.period)

    const params = new URLSearchParams(link.href)
    if (params.has('name')) {
      const name = params.get('name')
      params.set('name', encodeURIComponent(name))
    }
    params.set('network_ipv6', ipv6)
    params.set('period', period)
    params.set('location', store.location)

    link.href = decodeURIComponent(params.toString())
  })
}

export function toggleDropdown({ optnsContainer, chevronIcon, selectEl }) {
  optnsContainer?.classList.toggle('opened')
  chevronIcon?.classList.toggle('opened')
  selectEl?.classList.toggle('opened')
}

export function onPeriodSwitch({ packages, store, elm }) {
  const value = elm.getAttribute('data-period')
  const locationId = document.querySelector('[data-location]')?.getAttribute('data-location')
  store.location = locationId ? locationId : ''

  store.period = +value

  switchRadioUI({ elm, attribute: '[data-period]' })

  rewritePrices(packages, store)

  const packagesLinks = document.querySelectorAll('[data-cloud-link]')
  generateTariffLink({ packagesLinks, store })
}

// const dcDictionary = {
//   12: 'Poland',
//   13: 'Netherlands-2',
//   14: 'Netherlands-1',
// }
// const url = new URL(window.location.href)
// const dcIdFromParams = url.searchParams.get('dc')

// export function initializeStore({ store, locationSelectEl }) {
//   if (dcIdFromParams) {
//     // const chevronIcon = locationSelectEl.querySelector('[data-chevron-icon]')
//     // const packagesLinks = document.querySelectorAll('[data-cloud-link]')

//     // window.setLocation({
//     //   selectEl: locationSelectEl,
//     //   chevronIcon,
//     //   label: dcDictionary[dcIdFromParams],
//     // })

//     // store.location = dcIdFromParams

//     // generateTariffLink({ packagesLinks, store })
//   }
// }

// export function onLocationSwitch({ store, e }) {
//   store.location = e.target.value
//   const url = new URL(window.location.href)
//   url.searchParams.set('dc', e.target.value)
//   window.history.replaceState(null, '', url)
// }
